import { render } from "./InfraLayerFooter.vue?vue&type=template&id=761fea44&scoped=true&ts=true"
import script from "./InfraLayerFooter.vue?vue&type=script&lang=ts"
export * from "./InfraLayerFooter.vue?vue&type=script&lang=ts"

import "./InfraLayerFooter.vue?vue&type=style&index=0&id=761fea44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761fea44"]])

export default __exports__